"use client";

import React from "react";
import { useChartContext } from "../../../context/ChartContext";
import type { BaseDataPoint } from "../../../utils/charts";

export interface PointSeriesProps {
  data?: BaseDataPoint[];
  seriesKey?: string;
  color?: string;
  label?: string;
  radius?: number;
  opacity?: number;
  categoryColors?: Record<string, string>;
  categoryLabels?: Record<string, string>;
}

export const PointSeries: React.FC<PointSeriesProps> = ({
  data = [],
  color = "var(--color-viz-default)",
  radius = 3,
  opacity = 0.75,
  categoryColors = {},
}) => {
  const { xScale, yScale } = useChartContext();

  if (data.length === 0) return null;

  return (
    <g>
      {data.map((point, index) => (
        <circle
          key={`${point.xValue.getTime()}-${index}`}
          cx={xScale(point.xValue)}
          cy={yScale(point.chartYValue ?? point.yValue)}
          r={radius}
          fill={point.category && categoryColors[point.category] ? categoryColors[point.category] : color}
          fillOpacity={opacity}
        />
      ))}
    </g>
  );
};
